<template>
  <nav class="secondary-menu" role="navigation">
    <div class="secondary-menu-items">
      <h1>{{ menu.text }}</h1>
      <sub-menu
        v-for="submenu in submenus"
        :id="id(submenu)"
        :key="submenu.name"
        :sub-menu="submenu"
        :current-url="currentUrl"
        @itemSelected="item => $emit('itemSelected', item)"
      />
    </div>
    <button class="secondary-menu-close" @click.prevent="$emit('closed')">
      <span class="sr-only">{{ closeLabel }}</span>
      <span class="af-icons af-icons-cross"></span>
    </button>
  </nav>
</template>

<script>
import SubMenu from './SecondaryMenuSubMenu';

export default {
  components: {
    SubMenu
  },
  props: {
    menu: {
      type: Object,
      default: () => ({})
    },
    currentUrl: {
      type: String,
      default: null
    },
    closeLabel: {
      type: String,
      default: 'Close'
    }
  },
  computed: {
    submenus() {
      return this.menu.children || [];
    }
  },
  methods: {
    id(item) {
      return 'secondary-menu-' + item.name;
    }
  }
};
</script>
